
const now = (() => {
  let startAt = 0
  if (window.performance && typeof window.performance.now === 'function') {
    return () => window.performance.now()
  }
  startAt = +(new Date())
  return () => +(new Date()) - startAt
})()

const bench = (() => {
  const dom = {
    append: () => {
      const startAt = now()
      const div = document.createElement('div')
      document.body.appendChild(div)
      div.parentNode.removeChild(div)
      return parseInt(1000 / (now() - startAt))
    }
  }
  return {
    dom,
  }
})()
class Benchmark {
  constructor() {
    this.score = 0
    this.run = this.run.bind(this)
  }
  run() {
    this.score = bench.dom.append()
    return this
  }
}
const bm = new Benchmark()
export default bm

